<script>
    //import { onMount } from 'svelte';
    //import { BUILD_TIME } from '../buildTime.js';
    import {lastModifiedStore} from '../stores.js';
    
    let lastUpdate;
    // Automatically update lastModified when the store changes
    lastModifiedStore.subscribe(value => {
    lastUpdate = new Date(value);
    // console.log ('json file time 3: ', lastUpdate);
    });
    //const lastUpdate = new Date(BUILD_TIME);
    const options = { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',   
  };
    
  </script>
  
  <main>   
    <p>
    {#if lastUpdate}
    <div class="last-update">
      Data last update: {lastUpdate.toLocaleDateString('en-CH', options)} at {lastUpdate.toLocaleTimeString('en-CH', { hour: '2-digit', minute: '2-digit' })}
    </div>
    {/if}
    </p>
  </main>
  
  <style>
    .last-update {
      text-align: right;
      font-size: 0.9em;
      color: #666;
      margin-top: 20px;
      margin-right: 20px;
      font-style: italic;
    }
  </style>